import React from "react";
import { Routes, Route } from "react-router-dom";
import "./index.css";

import LinkHub from "./components/LinkHub";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<LinkHub />} />
      </Routes>
    </>
  );
};

export default App;
